import { ContextualMenu, DirectionalHint, IconButton } from "@fluentui/react";
import React, { useState } from "react";

type Props = {
  options: string[];
  // CSS selector of the element the menu opens under (the text field's input)
  target: string;
  onSelect: (option: string) => void;
  disabled?: boolean;
  ariaLabel?: string;
};

// Chevron rendered as the suffix of a text field: together they work as an
// editable drop-down - the value can be typed or picked from the options.
export const TextFieldOptionsButton = ({
  options,
  target,
  onSelect,
  disabled,
  ariaLabel,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconButton
        iconProps={{ iconName: "ChevronDown" }}
        ariaLabel={ariaLabel}
        disabled={disabled}
        onClick={() => setIsOpen(true)}
        styles={{ root: { height: "100%" } }}
      />
      {isOpen && (
        <ContextualMenu
          target={target}
          useTargetWidth
          directionalHint={DirectionalHint.bottomLeftEdge}
          onDismiss={() => setIsOpen(false)}
          items={options.map((option) => ({
            key: option,
            text: option,
            onClick: () => onSelect(option),
          }))}
        />
      )}
    </>
  );
};
